import config from "./config";

let qcPromise = null;

/**
 * 按需动态加载 QQ 互联 SDK（qc_jssdk.js）
 * 不再于 index.html 中同步加载，仅在实际需要 QQ 登录能力时才注入脚本，
 * 避免 connect.qq.com 拖慢页面首屏。
 */
export function loadQCSDK() {
  if (window.QC) {
    return Promise.resolve(window.QC);
  }
  if (!qcPromise) {
    qcPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://connect.qq.com/qc_jssdk.js";
      script.charset = "utf-8";
      script.async = true;
      script.setAttribute("data-appid", config.QQ_CLIENT_ID);
      script.setAttribute("data-redirecturi", config.QQ_REDIRECT_URL);
      script.onload = () => resolve(window.QC);
      script.onerror = () => {
        qcPromise = null;
        reject(new Error("QQ SDK 加载失败"));
      };
      document.head.appendChild(script);
    });
  }
  return qcPromise;
}
